import { render } from "./AdminWebhooksView.vue?vue&type=template&id=006c9d48&scoped=true"
import script from "./AdminWebhooksView.vue?vue&type=script&lang=js"
export * from "./AdminWebhooksView.vue?vue&type=script&lang=js"

import "./AdminWebhooksView.vue?vue&type=style&index=0&id=006c9d48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006c9d48"]])

export default __exports__